import isEmpty from 'lodash/isEmpty';


export default function validateInput(totalQuantity: number): any {
  const errors: any = {};
  if (totalQuantity === 0) {
    errors.totalQuantity = 'This field should be above 0';
  }
  return { errors, isValid: isEmpty(errors) };
}
